<div class="comments-section">
  <div class="comments-header">
    <div class="comments-count">
      <ptl-icon [icon]="LucideMessageSquare" size="s"></ptl-icon>
      <span>{{ totalCommentsCount }} {{ 'translations.comments.count' | transloco }}</span>
    </div>
  </div>

  <div class="comments-list" *ngIf="comments.length > 0">
    <ptl-comment-list
      [comments]="comments"
      [momentId]="momentId"
      [currentUserId]="currentUserId"
      (commentUpdated)="onCommentUpdated($event)"
      (commentDeleted)="onCommentDeleted($event)"
      (commentLiked)="onCommentLiked($event.commentId, $event.isLiked)"
      (replyCreated)="onReplyCreated($event.reply, $event.parentCommentId, $event.replyingToAuthorName)"
    >
    </ptl-comment-list>
  </div>

  <div class="empty-state" *ngIf="!isLoading && comments.length === 0">
    <ptl-icon [icon]="LucideMessageSquare" size="l"></ptl-icon>
    <p>{{ 'translations.comments.actions.emptyState' | transloco }}</p>
  </div>

  <div class="sticky-comment-input">
    <ptl-comment-input
      [momentId]="momentId"
      [placeholder]="'translations.comments.actions.addComment' | transloco"
      (commentCreated)="onCommentCreated($event)"
    >
    </ptl-comment-input>
  </div>
</div>
